export type ClaudeWatermarkDetection =
  | {
      status: 'unavailable';
      provider: 'anthropic';
      message: string;
      documentationUrl: string;
    }
  | {
      status: 'complete';
      provider: 'anthropic';
      score: number;
      label: string;
      evidenceTokens?: number;
    };

export interface ClaudeWatermarkDetector {
  readonly available: boolean;
  detect(text: string): Promise<ClaudeWatermarkDetection>;
}

/**
 * UI-safe placeholder for Anthropic's announced detector API. Replace this
 * adapter when Anthropic publishes an endpoint, authentication scheme, and
 * response semantics; the page does not need to know those details.
 */
export const claudeWatermarkDetector: ClaudeWatermarkDetector = {
  available: false,
  async detect(_text: string): Promise<ClaudeWatermarkDetection> {
    return {
      status: 'unavailable',
      provider: 'anthropic',
      message:
        'Anthropic has announced a detector API but has not published an integration contract. No text was sent.',
      documentationUrl: 'https://www.anthropic.com/news/claude-text-watermark',
    };
  },
};
